import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = window?.MAPBOX?.token ?? '';

export class Map extends AbstractComponent {
  init() {
    const { long, lat, zoom } = JSON.parse(this.el.dataset.map);
    const dots = JSON.parse(this.el.querySelector('script').innerText);

    const map = new mapboxgl.Map({
      container: this.el.querySelector('.locations-map__map'),
      style: window?.MAPBOX?.style ? window?.MAPBOX?.style : 'mapbox://styles/mapbox/light-v11',
      center: [long, lat],
      zoom: zoom,
      attributionControl: false,
    });

    map.on('wheel', event => {
      if (event.originalEvent.ctrlKey) {
        return;
      }

      if (event.originalEvent.metaKey) {
        return;
      }

      if (event.originalEvent.altKey) {
        return;
      }

      event.preventDefault();
    });

    const mainMarker = document.createElement('div');
    mainMarker.classList.add('main-marker');
    mainMarker.innerHTML = this.el.querySelector('[data-map-marker]')?.innerHTML || '';

    new mapboxgl.Marker(mainMarker)
      .setLngLat([long, lat])
      .addTo(map);

    dots.forEach((dot, i) => {
      const marker = document.createElement('div');
      marker.innerHTML = `<svg><use xlink:href="#${dot.category.value}"></use></svg><span>${i + 1}</span>`;

      new mapboxgl.Marker(marker)
        .setPopup(
          new mapboxgl.Popup({ offset: 25 })
            .setHTML(dot.title)
        )
        .setLngLat([dot.long, dot.lat])
        .addTo(map);
    })
  }
}

register('map', Map);
